import { KsOutstandingItem, KsPosition } from '../../../../../core/kickstart/kickstart.types';

/**
 * UI-DA-73-03's progress line, by the position the back end reports. `null`
 * where the back end reports none — the page then says nothing about what is
 * or is not needed. 🔒 "Nothing you need to do right now" only on CAPX_WORKING.
 * HELD names what clears the hold — the first item — and shows no figure.
 */
export function progressLine(
  position: KsPosition | null,
  items: readonly KsOutstandingItem[],
): string | null {
  switch (position) {
    case 'BUSINESS_NEEDED':
      return 'We need a few things from you before we can finish assessing — see below.';
    case 'CAPX_WORKING':
      return "We're assessing your application. There's nothing you need to do right now.";
    case 'PRE_ASSESSMENT_EXISTS':
      return "We've made an early assessment and are reviewing it. This is an early indication, not an offer.";
    case 'HELD': {
      const first =
        items.find((i) => i.owner === 'BUSINESS') ?? items.find((i) => i.owner === 'CAPX');
      return first
        ? `Your application is being processed and we'll be in contact. What moves it forward: ${first.text}`
        : "Your application is being processed and we'll be in contact.";
    }
    default:
      return null;
  }
}
